export default "/images/Climate-tech-finance.jpg";